import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  return (
    <div className="min-h-screen w-full bg-black flex items-center justify-center px-6 py-20">
      <Helmet>
        <title>Page Not Found | Frost & Grey</title>

        <meta name="robots" content="noindex, nofollow" />
        <meta name="googlebot" content="noindex, nofollow" />

        <meta
          name="description"
          content="This page does not exist. Return to Frost & Grey’s homepage."
        />
      </Helmet>

      <div className="max-w-md text-white">
        <div className="mb-10">
          <h1 className="text-3xl sm:text-4xl font-bold heading mb-2 text-red-600">
            Error 404
          </h1>
          <p className="text-2xl sm:text-3xl font-medium">
            Page Not Found
          </p>
        </div>

        <p className="mb-4">
          The page you are trying to access is unavailable. This might be due to a recent update to our website or an error in the URL.
        </p>
        <p className="">
          You can go back{" "}
          <Link
            to="/"
            className="text-red-600 hover:text-red-400 font-semibold heading"
          >
            home
          </Link>{" "}
          to find the information you need, or contact us if you need further assistance.
        </p>

        <div className="mt-6">
          <p className="mb-2">Thank you,</p>
          <p className="font-bold heading">Frost &amp; Grey</p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
